import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46fae5d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "desktop d-flex p-2" }
const _hoisted_2 = { class: "meta" }
const _hoisted_3 = { class: "meta-content" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "body" }

import axios from "axios";
import { format } from "date-fns";
import { startCase, take } from "lodash";
import { onMounted, ref } from "vue";

interface NewsItem {
	title: string;
	body: string;
	link: string;
	date: Date;
	tag: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LatestNews',
  setup(__props) {

// import crmApi from "@/crmApi/crmApi";
const loading = ref(false as boolean);
const items = ref([] as NewsItem[]);
const getLatestNewsRss = () => {
	loading.value = true;
	let rss = encodeURIComponent(`https://ohjeet.hakosalo.fi/?op=APIRSS`);
	axios.get("Guide/rss/" + rss)
	.then((resp) => {
		let data = resp.data || "";
		data = data.split(":description").join("");
		data = data.split("<![CDATA[").join("");
		data = data.split("]]>").join("");
		loading.value = false;
		const doc = new window.DOMParser().parseFromString(data, "text/xml");
		const newsItems = [] as NewsItem[];
		doc.querySelectorAll("item").forEach((r) => {
			const dateStr = r.querySelector("pubDate")?.innerHTML || "";
			//console.log("dateStr raw :>> ", dateStr);

			const item: NewsItem = {
				title: r.querySelector("title")?.innerHTML || "",
				body: r.querySelector("description")?.innerHTML || "",
				link: r.querySelector("link")?.innerHTML || "",
				tag: r.querySelector("category")?.innerHTML || "",
				date: new Date(isNaN(parseInt(dateStr)) ? dateStr : parseInt(dateStr)),
			};
			newsItems.push(item);
		});
		items.value = take(newsItems, 5);
	}).catch(() => loading.value = false);
};
const dateformat = (date: Date) => {
	let s = format(date, "dd.MM.yyyy");
	return s;
}
onMounted(() => {
	getLatestNewsRss();
})

return (_ctx: any,_cache: any) => {
  const _component_HakoSpinner = _resolveComponent("HakoSpinner")!

  return (_openBlock(), _createElementBlock("div", null, [
    (loading.value)
      ? (_openBlock(), _createBlock(_component_HakoSpinner, { key: 0 }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(items.value, (row) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card mt-2 mb-2 news-item",
            key: row.title
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, _toDisplayString((dateformat(row.date))), 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(startCase)(row.tag)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    href: row.link,
                    target: "_blank"
                  }, _toDisplayString(row.title), 9, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, _toDisplayString(row.body), 1)
              ])
            ])
          ]))
        }), 128))
  ]))
}
}

})